import React from "react";
import { Accordion } from "react-bootstrap";
import Translator, { __ } from "services/Translator";

function VIPFaqs(props) {
  const accordionToggled = (lastOpenItem) => {
    if (lastOpenItem !== null) {
      lastOpenItem = parseInt(lastOpenItem);
    }
  };

  const vipFaqs = props.vipFaqs || [];

  return (
    <>
      <div className="access_control_area vip-faqs">
        <div className="commonHeadingArea">
          <div className="leftBar"></div>
          <div className="headingText">{__("FAQ - VIP Levels")}</div>
          <div className="rightBar"></div>
        </div>

        <Accordion onSelect={accordionToggled}>
          {vipFaqs.map((faq, index) => (
            <Accordion.Item
              key={index}
              eventKey={index.toString()}
              className="faq-item chimp-accordion"
            >
              <Accordion.Header
                className={"faq__question " + (props.landingType || "")}
              >
                {__(faq.title)}
              </Accordion.Header>
              <Accordion.Body className="faq__answer">
                {__(faq.description)}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </>
  );
}

export default VIPFaqs;
